import { BUTTON_CLASSES } from '@region13/ui'
import { createFileRoute } from '@tanstack/react-router'
import { useNavTitle } from '../lib/nav'
import { useQuery } from '@tanstack/react-query'
import { api, type CoachTeamWithGames } from '../lib/api'
import { Card } from '../components/ui/Card'
import { PHONE_TAP } from '../components/ui'
import { TeamScope } from '../components/TeamScope'

export const Route = createFileRoute('/forms')({ component: FormUploads })

// An <a>, not <Button>: it leaves the portal for the region's forms page.
// The primary button's classes, at the phone tap height.
const LINK_BUTTON = `${BUTTON_CLASSES.primary} ${PHONE_TAP} justify-center`

/** One team's upload link, from `GET /api/coach/teams/:ext/form-link`. */
export function TeamFormLink({ team }: { team: CoachTeamWithGames }) {
  const q = useQuery({
    queryKey: ['form-link', team.externalId],
    queryFn: () => api.formLink(team.externalId),
  })

  return (
    <Card as="section">
      <h2 className="font-semibold text-ink">{team.externalId}</h2>
      {q.isLoading ? (
        <p role="status" className="text-sm text-ink-soft">Loading…</p>
      ) : q.isError ? (
        <p role="alert" className="text-sm text-brand-red-dark">Couldn't load your forms link. Please try again.</p>
      ) : q.data?.url ? (
        <div>
          <a href={q.data.url} target="_blank" rel="noopener" className={LINK_BUTTON}>
            Upload Forms
          </a>
        </div>
      ) : (
        <p className="text-sm text-ink-soft">No forms link is set up for this team yet.</p>
      )}
    </Card>
  )
}

function FormUploads() {
  return (
    <TeamScope
      heading={useNavTitle()}
      emptyText="No teams found for your account this season."
      hint="Pick a team to see its forms link."
      headerExtra={
        <p className="text-sm text-ink">Upload your team's Concussion and SCA Forms and check progress here.</p>
      }
    >
      {(team) => <TeamFormLink team={team} />}
    </TeamScope>
  )
}
